export const HOVER_ZOOM_IMAGE_TRANSITION = 'all 0.3s ease-in-out';

export const HOVER_ZOOM_IMAGE_TRANSFORM = 'scale(1.1)';
